module.exports = __webpack_public_path__ + "static/dancing_sword-a746cf92d9fb0cc005430bdd609c5f35.jpeg";